<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"> </p>
<p class="center-para"><a id="page_i"></a><span class="smallcaps">ALSO BY THOMAS REPPETTO</span></p>
<p class="para"> </p>
<p class="center-para"><em>American Mafia: A History of Its Rise to Power</em></p>
<p class="para"> </p>
<p class="center-para"><em>NYPD: A City and Its Police</em></p>
<p class="para"> </p>
<p class="center-para"><em>The Blue Parade</em></p>
<p class="para"> </p>
<p class="center-para"><em>Residential Crime</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?754328ec